@if (!isCloseButton) {
  <button class="btn-overlay ms-2" (click)="onVr()">
    <img src="assets/img/icons/vr.svg" class="" alt="Vr icon">
  </button>
}
@if (isCloseButton && isFullscreen) {
  <button class="btn-overlay m-4 mr-15 absolute top-0 right-0 " (click)="onVr()">
    <img src="assets/img/icons/vr.svg" class="" alt="Vr icon">
  </button>
}